import React, { FC, useCallback } from "react";
import '../../styles/views/pushPage/pushPage.scss';
import { PageRoutes, useStore, useViewModel } from "../../utils";
import { PushStore } from "../../store";
import { PushNotification } from "../../components/pushNotifications/PushNotification";
import { MeetingViewModel } from "../../components";
import { MeetingPlanerViewModel } from "../meetingPlanerPage";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { FilterMobile } from "../../components/filter/FilterMobile";

export const PushPage: FC = observer(() => {
  const pushStore = useStore(PushStore);
  const meetingViewModel = useViewModel(MeetingViewModel);
  const meetingPlanerViewModel = useViewModel(MeetingPlanerViewModel);
  const navigate = useNavigate();

  const openMeeting = useCallback((meetingId: number, isEditable: boolean) => {
    meetingId && meetingViewModel.loadMeetingById(meetingId, 'inner_meeting').then(() => {
      if (isEditable) {
        meetingPlanerViewModel.setMembers(meetingViewModel.meetingData.members, meetingViewModel.meetingData?.meetingConfirmation);
        meetingPlanerViewModel.setDate(meetingViewModel.meetingData.startDate);
      }
      navigate(PageRoutes.CALENDAR_PAGE);
    });
  }, []);

  return (
    <>
      <FilterMobile />
      <div className="push-page">
        {(pushStore.data.length !== 0)
          ? pushStore.data.map((elem) => (
            <PushNotification 
              isPushInactive={pushStore.isPushInactive}
              answerMeeting={pushStore.answerMeeting} 
              offerTime={pushStore.offerTime}
              openMeeting={openMeeting} 
              key={elem.id} 
              notification={elem}
            />
          ))
          : <p className="empty-pushs">Уведомлений нет</p>
        }
      </div>
    </>
  )
})